// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomBreadcrumb_container__z8QD2","containerItem":"CustomBreadcrumb_containerItem__CdJd1"};